import type { EventHint, Options, TransactionEvent } from "@sentry/core";

export function chainBeforeSendTransaction(
  base: Options["beforeSendTransaction"],
  user: Options["beforeSendTransaction"],
) {
  return async (event: TransactionEvent, hint: EventHint) => {
    if (base) {
      const baseResult = await base(event, hint);
      if (baseResult === null) {
        return null;
      }
      event = baseResult;
    }

    if (typeof user === "function") {
      return user(event, hint);
    }

    return event;
  };
}
